import type { ComputedRef, Ref, WritableComputedRef } from 'vue'

import { useChangelogStore } from '@entities/changelog'

import { useFiltersChangelog } from './filters-changelog.hook'

interface FiltersEntityChangelogReturn {
  refSearch: Ref<string>
  refDateRange: WritableComputedRef<Date[] | null>
  isLoading: ComputedRef<boolean>
  setSearch: (value: string | number) => void
  handleSearch: () => Promise<void>
  handleClear: () => Promise<void>
}

/**
 * The store trims the search on every write, so a controlled input bound to it straight away would eat the
 * space the admin just typed; the text is kept locally and handed to the store on submit.
 */
export const useFiltersEntityChangelog = (): FiltersEntityChangelogReturn => {
  const store = useChangelogStore()
  const filters = useFiltersChangelog()

  const refSearch = ref<string>(store.getFilterSearch ?? '')

  const setSearch = (value: string | number): void => {
    refSearch.value = String(value)
  }

  const handleSearch = async (): Promise<void> => {
    filters.refSearch.value = refSearch.value
    await filters.handleSearch()
  }

  watch(() => store.getFilterSearch, (value) => {
    refSearch.value = value ?? ''
  })

  return {
    refSearch,
    refDateRange: filters.refDateRange,
    isLoading: filters.isLoading,
    setSearch,
    handleSearch,
    handleClear: filters.handleClear,
  }
}
